const PROFILE_PATH_REGEX = /^\/user\/([^/?#]+)/;

/**
 * Extracts the username from a `/user/:username` URL path.
 *
 * @param {string} [pathname=window.location.pathname] - The URL path to parse.
 * @returns {string | null} The decoded username, or `null` if the path is not a
 *   profile path or the username contains whitespace.
 */
export const getProfileUsernameFromPath = (
  pathname = typeof window !== "undefined" ? window.location.pathname : ""
) => {
  const match = pathname.match(PROFILE_PATH_REGEX);
  if (!match) return null;
  let username;
  try {
    username = decodeURIComponent(match[1]);
  } catch {
    return null;
  }
  if (/[\s/?#]/.test(username)) return null;
  return username;
};
